import React, { useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";

import Button from "../../UI/Button/Button";
import Section from "../../UI/Others/Section";
import Headline from "../../Headline/Headline";
import * as GlobalConstant from "../../Constants/GlobalConstant";

import styles from "./Pricing.module.scss";

const Pricing = () => {
    const intl = useIntl();
    const user = useSelector(state => state.contacts.user);

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    const title = intl.messages.pricingTitle;
    const subtitle = intl.messages.pricingMessage;

    let header_txt1 = intl.messages.pricingHeader1;
    let header_txt2 = intl.messages.pricingHeader2;
    let isAuthenticated = user != null;
    let button_label = isAuthenticated ? intl.messages.pricingManage : intl.messages.pricingLogin;

    function PricingCard(props) {
        return (
            <div className="col-lg-6">
                <div className="card text-center" >
                    <div className="panel bg-fog mb-3">{props.header}</div>
                    <span><h5 className="card-title">{props.title}</h5></span>
                    <div className="card-text">
                        {props.children}
                    </div>
                </div>
            </div>
        );
    }

    function Bloc(props) {
        return (
            <div>
                <img src={props.src} width="36" className="mb-2 mt-2" alt="" />
                <div>{props.txt}</div>
                <div className="mb-2 mt-3">{props.children}</div>
            </div>
        );
    }

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <div className="row">
                {/* Message d'accueil */}
                <div className="col">
                    <div className="card">
                        <div className="card-text">{intl.messages.pricingDescription}</div>
                    </div>
                </div>
            </div>

            <Section 
                title={intl.messages.pricingSection} 
                className="bg-blue"
            />
            
            <div className="row">
                <PricingCard
                    header={header_txt1}
                    title="PAY AS YOU GO"
                >
                    <div className="text-center">
                        <ul className="list-unstyled">
                            <li><b>{intl.messages.pricingList1Txt1}</b></li>
                            <li><b>{intl.messages.pricingList1Txt2}</b></li>
                            <li><b>{intl.messages.pricingList1Txt3}</b></li>
                        </ul>
                    </div>

                    <div>
                        <Link to={isAuthenticated ? GlobalConstant.DASHBOARD_PATH : GlobalConstant.LOGIN_PATH} className="text-decoration-none">
                            <Button
                                className="btn-orange"
                                label={button_label}
                            />
                        </Link>
                    </div>
                    <div className="h-25 p-3"></div>

                    <Bloc
                        src="./images/pricing/payasyougo_icon1.svg"
                        txt={intl.messages.pricing1Bloc1}
                    />

                    <hr className="w-50" />

                    <Bloc
                        src="./images/pricing/payasyougo_icon2.svg"
                        txt={intl.messages.pricing1Bloc2}
                    />

                    <hr className="w-50" />

                    <Bloc
                        src="./images/pricing/payasyougo_icon4.svg"
                        txt={intl.messages.pricing1Bloc3}
                    >
                        <a
                            className="btn btn-orange"
                            href="mailto:support@openrainbow.com?subject=[RainbowHUB] Sales support"
                        >{intl.messages.pricingContact}
                        </a>
                    </Bloc>

                    <hr className="w-50" />

                    <Bloc
                        src="./images/pricing/payasyougo_icon3.svg"
                        txt={intl.messages.pricing1Bloc4}
                    >

                        {/* Pricing details => button toggle */}
                        <button id="toggleBtn"
                            data-toggle="collapse" data-target="#price"
                            className="btn btn-orange btn-toggle collapsed " //dropdown-toggle
                        >
                            {intl.messages.pricingDetails}
                        </button>

                        <div id="price" className="collapse border border-orange">
                            <p className="py-2">{intl.formatMessage({ id: "pricingDetailTxt1" }, { num: "[1]" })}</p>

                            <div>
                                <div className="lead font-weight-normal text-uppercase text-orange mt-2">{intl.messages.pricingDetailTitle2}</div>
                                <small>{intl.messages.pricingDetailTxt2}</small>
                                <br />
                                <span className={"text-orange " + styles.planContentGroupValue}>{intl.messages.pricingDetailPrix2}</span>
                                <br />
                                <small>{intl.formatMessage({ id: "pricingDetailNote2" }, { num: "[2]" })}</small>
                            </div>
                            <div>
                                <div className="lead font-weight-normal text-uppercase text-orange mt-2 mb-1">{intl.messages.pricingDetailTitle3}</div>
                                <small>{intl.messages.pricingDetailTxt3}</small>
                                <br />
                                <span className={"text-orange " + styles.planContentGroupValue}>{intl.messages.pricingDetailPrix3}</span>
                                <br />
                                <small>{intl.formatMessage({ id: "pricingDetailNote3" }, { num: "[3]" })}</small>
                            </div>
                            <div>
                                <div className="lead font-weight-normal text-uppercase text-orange mt-2 mb-1">{intl.messages.pricingDetailTitle4}</div>
                                <small>{intl.messages.pricingDetailTxt4}</small>
                                <br />
                                <span className={"text-orange " + styles.planContentGroupValue}>{intl.messages.pricingDetailPrix4}</span>
                            </div>
                            <div>
                                <div className="lead font-weight-normal text-uppercase text-orange mt-2 mb-1">{intl.messages.pricingDetailTitle5}</div>
                                <small>{intl.messages.pricingDetailTxt5},</small>
                                <br />
                                <span className={"text-orange " + styles.planContentGroupValue}>{intl.messages.pricingDetailPrix5}</span>
                            </div>

                            <div className="h-25 p-3"></div>

                            <div className="text-left px-2">
                                <b>{intl.messages.pricingNotes}</b>
                                <p>{"[1] " + intl.messages.pricingNote1}</p>
                                <p>{"[2] " + intl.messages.pricingNote2}</p>
                                <p>{"[3] " + intl.formatMessage({ id: "pricingNote3" }, { num: "[2]" })}</p>
                            </div>

                        </div>

                    </Bloc>

                    <hr className="w-50" />

                    <Bloc
                        src="./images/pricing/payasyougo_icon5.svg"
                        txt={intl.messages.pricing1Bloc5}
                    />

                    <div className="text-left">
                        <b>{intl.messages.pricingNotes}</b>
                        <p>{"[1] " + intl.messages.pricingNote}</p>
                    </div>

                </PricingCard>

                <PricingCard
                    header={header_txt2}
                    title="BUSINESS PROJECTS"
                >
                    <div className="text-center">
                        <ul className="list-unstyled">
                            <li><b>{intl.messages.pricingList2Txt1}</b></li>
                            <li><b>{intl.messages.pricingList2Txt2}</b></li>
                            <li><b>{intl.messages.pricingList2Txt3}</b></li>
                        </ul>
                    </div>

                    <div>
                        <a
                            className="btn btn-green"
                            href="mailto:support@openrainbow.com?subject=[RainbowForDevelopers] Sales support"
                        >{intl.messages.pricingContact}
                        </a>
                    </div>
                    <div className="h-25 p-3"></div>

                    <Bloc
                        src="./images/pricing/businessprojects_icon1.svg"
                        txt={intl.messages.pricing2Bloc1}
                    />

                    <hr className="w-50" />

                    <Bloc
                        src="./images/pricing/businessprojects_icon2.svg"
                        txt={intl.messages.pricing2Bloc2}
                    />

                    <hr className="w-50" />

                    <Bloc
                        src="./images/pricing/businessprojects_icon3.svg"
                        txt={intl.messages.pricing2Bloc3}
                    />

                    <hr className="w-50" />

                    <Bloc
                        src="./images/pricing/businessprojects_icon4.svg"
                        txt={intl.messages.pricing2Bloc4}
                    />

                    <hr className="w-50" />

                    <Bloc
                        src="./images/pricing/businessprojects_icon5.svg"
                        txt={intl.messages.pricing2Bloc5}
                    />

                    <div className="h-25 p-3"></div>
                </PricingCard>

            </div>
        </div>
    );
}

export default Pricing;